import { render, staticRenderFns } from "./associated_customers_box.vue?vue&type=template&id=da85f690&scoped=true"
import script from "./associated_customers_box.vue?vue&type=script&lang=js"
export * from "./associated_customers_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da85f690",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da85f690')) {
      api.createRecord('da85f690', component.options)
    } else {
      api.reload('da85f690', component.options)
    }
    module.hot.accept("./associated_customers_box.vue?vue&type=template&id=da85f690&scoped=true", function () {
      api.rerender('da85f690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_org/associated/associated_customers/associated_customers_box.vue"
export default component.exports